import script from "./OTabelaDestravarPeriodo.vue?vue&type=script&lang=ts&setup=true"
export * from "./OTabelaDestravarPeriodo.vue?vue&type=script&lang=ts&setup=true"

import "./OTabelaDestravarPeriodo.vue?vue&type=style&index=0&id=5e8c6961&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e8c6961"]])

export default __exports__